import { ValidationCounts } from './createValidationSummary';
import { ValidationResult } from './validateSchema';

/**
 * Calculate validation counts from a validation result
 *
 * @param result - The validation result to analyze.
 * @returns An object containing the counts of errors, warnings, and total messages.
 */
export const getValidationCounts = (
  result: ValidationResult
): ValidationCounts => {
  const errors = result.messages.filter((m) => m.severity === 'error').length;
  const warnings = result.messages.filter(
    (m) => m.severity === 'warning'
  ).length;

  return {
    errors,
    warnings,
    total: errors + warnings,
  };
};
